import React from "react";

import PromptPickerList from "./PromptPickerList";
import { filterSlashPrompts } from "../utils/slashPromptUtils";
import type { CrmRecordType, ManagingPromptCatalogEntry } from "../types/chat.types";

export interface SlashPromptMenuProps {
  prompts: ManagingPromptCatalogEntry[];
  recordType?: CrmRecordType | null;
  query: string;
  onSelect: (prompt: ManagingPromptCatalogEntry) => void;
  hasCallRecordingWithTranscript?: boolean;
  highlightedIndex?: number;
  onHighlightChange?: (index: number) => void;
  className?: string;
}

const SlashPromptMenu: React.FC<SlashPromptMenuProps> = ({
  prompts,
  recordType,
  query,
  onSelect,
  hasCallRecordingWithTranscript,
  highlightedIndex,
  onHighlightChange,
  className = "",
}) => {
  const filtered = filterSlashPrompts(prompts, {
    recordType,
    query,
    hasCallRecordingWithTranscript,
  });

  return (
    <div
      className={`absolute bottom-full left-0 right-0 z-30 mb-1 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg ${className}`}
      role="presentation"
      aria-expanded="true"
    >
      <PromptPickerList
        listId="slash-prompt-list"
        prompts={filtered}
        recordType={recordType}
        query={query}
        onSelect={onSelect}
        hasCallRecordingWithTranscript={hasCallRecordingWithTranscript}
        highlightedIndex={highlightedIndex}
        onHighlightChange={onHighlightChange}
      />
    </div>
  );
};

export default SlashPromptMenu;
